<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="2" />
    <h4>Sesiones</h4>
    <hr />

    <DataTable
      :data="sesions"
      :columns="columnas"
      idField="idSesion"
      mensajeVacio="No hay sesiones registradas."
      :mostrarBotonNuevo="true"
      :mostrarEditar="true"
      :mostrarVer="true"
      :mostrarEliminar="true"
      @refresh="getData"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idSesion)"
      @view="row => abrirEditar(row.idSesion)"
      @delete="row => deleteSesion(row.idSesion)"
    >
      <!-- Búsqueda por nombre de usuario -->
      <template #acciones-extra>
        <div class="col-auto d-flex align-items-center gap-1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="nombreBusqueda"
            placeholder="Buscar usuario..."
            style="width:220px; text-transform:uppercase"
            @keyup.enter="getDataNombre"
          />
          <button
            class="btn btn-outline-primary btn-sm"
            @click="getDataNombre"
            title="Buscar"
          >
            <span class="material-icons" style="font-size:16px">search</span>
          </button>
        </div>
      </template>

      <!-- Fecha de registro formateada -->
      <template #cell-fechaReg="{ row }">
        {{ getFormattedDate(row.fechaReg) }}
      </template>

      <!-- UserAgent truncado con tooltip -->
      <template #cell-userAgent="{ row }">
        <span
          :title="row.userAgent"
          style="cursor:help; display:block; max-width:220px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap"
        >
          {{ row.userAgent }}
        </span>
      </template>
    </DataTable>

    <!-- ── Modal ──────────────────────────────────────────────────── -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <!-- ID solo en edición -->
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">ID</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoSesion.idSesion"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <!-- ID Usuario -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">ID Usuario</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoSesion.idUsuario"
                      style="text-transform:uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <!-- Fecha de registro (solo lectura) -->
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Fecha de Registro</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoSesion.fechaReg"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <!-- Dirección IP -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Dirección IP</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoSesion.direccionIp"
                      required
                    />
                  </div>
                </div>
              </div>
              <!-- User Agent -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">User Agent</label>
                  </div>
                  <div class="col-10">
                    <textarea
                      class="form-control"
                      v-model="datoSesion.userAgent"
                      rows="3"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarSesion"
              v-if="btnCrear"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click.prevent="actualizarSesion"
              v-if="btnEditar"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
              Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout          from "@/components/Layout.vue";
import Footer          from "@/components/Footer.vue";
import DataTable       from "@/components/DataTable.vue";
import api             from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import dateFormat      from "@/modules/dateFormat.js";
import Swal            from "sweetalert2";
import * as $          from "jquery";
window["$"]      = $;
window["jQuery"] = $;

export default {
  name: "SesionList",
  components: { Layout, Footer, DataTable },

  data() {
    return {
      sesions:        [],
      datoSesion:     {},
      nombreBusqueda: "",
      titulo:         "",
      btnCrear:       false,
      btnEditar:      false,
      modalWindow:    true,
    };
  },

  computed: {
    columnas() {
      return [
        // fechaReg usa slot #cell-fechaReg para formateo
        { label: "Fecha Registro", field: "fechaReg"      },
        { label: "Dirección IP",   field: "direccionIp"   },
        // userAgent usa slot para truncar texto largo
        { label: "User Agent",     field: "userAgent"     },
        { label: "Usuario",        field: "usuarioNombre" },
      ];
    },
  },

  mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.getData();
  },

  methods: {
    // ── Utilidades ────────────────────────────────────────────
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },

    // ── Carga de datos ────────────────────────────────────────
    getData() {
      this.nombreBusqueda = "";
      api.get("/vwsesions")
        .then(r => { this.sesions = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al cargar sesiones:", e));
    },

    getDataNombre() {
      const nombre = this.nombreBusqueda.trim();
      if (!nombre) { this.getData(); return; }
      api.get("/vwsesions/nombre/" + nombre)
        .then(r => { this.sesions = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al buscar sesión:", e));
    },

    // ── Validación ────────────────────────────────────────────
    validarForm() {
      return validarForm(
        this.datoSesion,
        ["idUsuario", "direccionIp", "userAgent"],
        ["ID Usuario", "Dirección IP", "User Agent"]
      );
    },

    // ── CRUD ──────────────────────────────────────────────────
    async guardarSesion() {
      if (this.validarForm() !== 1) return;
      try {
        this.datoSesion.idUsuario = window.sessionStorage.getItem("idUsuario");
        await api.post("/sesions", this.datoSesion);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Sesión creada exitosamente." });
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },

    async actualizarSesion() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/sesions", this.datoSesion);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Sesión actualizada exitosamente." });
        this.getData();
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },

    async deleteSesion(idSesion) {
      const confirm = await Swal.fire({
        title:             "¿Eliminar sesión?",
        text:              "Esta acción no se puede deshacer.",
        icon:              "warning",
        showCancelButton:  true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText:  "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/sesions/" + idSesion);
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },

    // ── Modales ───────────────────────────────────────────────
    abrirModalCrear() {
      this.modalWindow = true;
      this.datoSesion  = {};
      this.titulo      = "Crear Sesión";
      this.btnCrear    = true;
      this.btnEditar   = false;
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    async abrirModalEditar(idSesion) {
      this.modalWindow = true;
      this.titulo      = "Editar Sesión";
      this.btnCrear    = false;
      this.btnEditar   = true;
      try {
        const resp      = await api.get("/vwsesions/" + idSesion);
        this.datoSesion = resp.data;
      } catch (e) {
        console.error("Error al cargar sesión:", e);
        return;
      }
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    abrirEditar(idSesion) {
      if (idSesion != null) this.$router.push("/sesionmd/" + idSesion);
    },
  },
};
</script>